import { motion } from "framer-motion";
import { Inbox, Cpu, CheckCheck, ArrowRight } from "lucide-react";
import { Editable } from "@/components/builder/Editable";

const STEPS = [
  { icon: Inbox, key: "ricevi", title: "Ricevi", desc: "Email, PEC e WhatsApp arrivano in un unico posto." },
  { icon: Cpu, key: "elabora", title: "L'AI elabora", desc: "Legge, capisce, classifica, apre le pratiche e valuta l'urgenza." },
  { icon: CheckCheck, key: "decidi", title: "Tu decidi", desc: "Approvi le bozze, assegni i fornitori e condividi con i condomini." },
];

export const HowItWorks = () => {
  return (
    <section id="come-funziona" data-testid="how-it-works" className="bg-white">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <Editable as="p" path="how.eyebrow" className="mb-3 block text-xs font-bold uppercase tracking-[0.16em] text-primary">Come funziona</Editable>
        <Editable as="h2" path="how.title" className="block max-w-2xl font-display text-4xl font-extrabold text-foreground sm:text-5xl">Da messaggio disordinato ad azione concreta.</Editable>
        <div className="mt-12 grid items-stretch gap-4 md:grid-cols-[1fr_auto_1fr_auto_1fr]">
          {STEPS.map((s, i) => (
            <div key={s.key} className="contents">
              <motion.div initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.4, delay: i * 0.1 }} className="card-soft card-soft-hover p-7">
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-primary/10 text-primary"><s.icon className="h-6 w-6" strokeWidth={2} /></span>
                <h3 className="mt-4 text-xl font-bold text-foreground"><Editable path={`how.${s.key}.title`}>{s.title}</Editable></h3>
                <p className="mt-2 text-sm leading-6 text-muted-foreground"><Editable path={`how.${s.key}.desc`}>{s.desc}</Editable></p>
              </motion.div>
              {i < STEPS.length - 1 && (<div className="hidden items-center justify-center md:flex"><ArrowRight className="h-6 w-6 text-muted-foreground/40" /></div>)}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
